import React from 'react'

export default function Footer() {
    return (
        <div className="text-indigo-300 text-3xl font-serif italic h-20 text-center">
        “ Truth can only be found in one place: the code. ”
            
        </div>
    )
}
